import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

// Components
import { NavbarComponent } from './views/global/navbar/navbar.component';
import { FooterComponent } from './views/global/footer/footer.component';
import { LoaderSComponent } from './views/global/loader/loader.component';



@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    LoaderSComponent,
    NavbarComponent,
    FooterComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  public isOnLine(): boolean {
    return navigator.onLine;
  }
}
